export const validateDecimalInput = function (event: KeyboardEvent) {
  const inputChar = String.fromCharCode(event.charCode);
  const currentValue = (event.target as HTMLInputElement).value;

  const isValidChar = /[0-9\.]/.test(inputChar);
  if (!isValidChar) {
    event.preventDefault();
    return;
  }


  if (inputChar === '.' && currentValue.includes('.')) {
    event.preventDefault();
    return;
  }

  const decimalIndex = currentValue.indexOf('.');
  if (decimalIndex >= 0) {
    const decimalPart = currentValue.substring(decimalIndex + 1);
    if (decimalPart.length >= 2 && (event.target as HTMLInputElement).selectionStart! > decimalIndex) {
      event.preventDefault();
    }
  }
}

export const OOPS_ERROR_MESSAGE = 'Oops! Something went wrong, please try again in a few minutes.';

export function extractErrorDetail(e: any): string {
  if (e == null || e === '') {
    return '';
  }
  if (typeof e === 'string') {
    return e.trim();
  }
  if (typeof e === 'number') {
    return String(e);
  }
  // API used to return data:false on Sage failures; skip bare booleans in [detail].
  if (typeof e === 'boolean') {
    return '';
  }
  if (e.data != null && e.data !== e) {
    var fromData = extractErrorDetail(e.data);
    if (fromData) {
      return fromData;
    }
  }
  if (e.error != null && e.error !== e) {
    var fromError = extractErrorDetail(e.error);
    if (fromError) {
      return fromError;
    }
  }
  if (e.message && typeof e.message === 'string') {
    return e.message.trim();
  }
  return '';
}

export function formatOopsErrorMessage(e: any): string {
  var detail = extractErrorDetail(e);
  if (detail && detail !== OOPS_ERROR_MESSAGE) {
    return OOPS_ERROR_MESSAGE + ' [' + detail + ']';
  }
  return OOPS_ERROR_MESSAGE;
}
